export const getLocationsData = state => state.locations.all;
export const getLocationData = state => state.locations.location;
export const locationsIsFetching = state => state.locations.loading.all;
export const locationIsFetching = state => state.locations.loading.location;